import { render, staticRenderFns } from "./BankTransferTab.vue?vue&type=template&id=7493caf0&scoped=true&"
import script from "./BankTransferTab.vue?vue&type=script&lang=js&"
export * from "./BankTransferTab.vue?vue&type=script&lang=js&"
import style0 from "./BankTransferTab.vue?vue&type=style&index=0&id=7493caf0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7493caf0",
  null
  
)

export default component.exports